{
  "": [
    [
      {
        "propertyType": "ZIP"
      }
    ],
    [
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "COUNTY"
      }
    ],
    [
      {
        "propertyType": "DISTRICT"
      }
    ],
    [
      {
        "propertyType": "PROVINCE"
      }
    ],
    [
      {
        "propertyType": "STATE"
      }
    ],
    [
      {
        "propertyType": "SUBURB"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "AT": [
    [
      {
        "propertyType": "ZIP",
        "length": 6
      },
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "BG": [
    [
      {
        "propertyType": "ZIP",
        "length": 4
      },
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "BE": [
    [
      {
        "propertyType": "ZIP",
        "length": 4
      },
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "CY": [
    [
      {
        "propertyType": "ZIP",
        "length": 4
      },
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "COUNTY"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "CZ": [
    [
      {
        "propertyType": "ZIP",
        "length": 5
      },
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "DE": [
    [
      {
        "propertyType": "ZIP",
        "length": 5
      },
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "DK": [
    [
      {
        "propertyType": "DISTRICT"
      }
    ],
    [
      {
        "propertyType": "ZIP",
        "length": 4
      },
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "EE": [
    [
      {
        "propertyType": "COUNTY"
      }
    ],
    [
      {
        "propertyType": "ZIP",
        "length": 5
      },
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "ES": [
    [
      {
        "propertyType": "ZIP",
        "length": 5
      },
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "PROVINCE"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "FI": [
    [
      {
        "propertyType": "ZIP",
        "length": 5
      },
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "FR": [
    [
      {
        "propertyType": "COUNTY"
      }
    ],
    [
      {
        "propertyType": "ZIP",
        "length": 5
      },
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "GR": [
    [
      {
        "propertyType": "ZIP",
        "length": 5
      },
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "GB": [
    [
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "COUNTY"
      }
    ],
    [
      {
        "propertyType": "ZIP"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "HR": [
    [
      {
        "propertyType": "COUNTY"
      }
    ],
    [
      {
        "propertyType": "ZIP",
        "length": 5
      },
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "HU": [
    [
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "ZIP"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "IE": [
    [
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "COUNTY"
      }
    ],
    [
      {
        "propertyType": "ZIP"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "IT": [
    [
      {
        "propertyType": "ZIP",
        "length": 5
      },
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "LT": [
    [
      {
        "propertyType": "LOCALITY"
      },
      {
        "propertyType": "ZIP",
        "length": 5
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "LU": [
    [
      {
        "propertyType": "LOCALITY"
      },
      {
        "propertyType": "ZIP",
        "length": 4
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "LV": [
    [
      {
        "propertyType": "LOCALITY"
      },
      {
        "propertyType": "ZIP",
        "length": 4
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "MT": [
    [
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "ZIP"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "NL": [
    [
      {
        "propertyType": "ZIP",
        "length": 7
      },
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "PL": [
    [
      {
        "propertyType": "ZIP",
        "length": 6
      },
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "PT": [
    [
      {
        "propertyType": "ZIP",
        "length": 8
      },
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "RO": [
    [
      {
        "propertyType": "ZIP",
        "length": 6
      },
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "SE": [
    [
      {
        "propertyType": "ZIP",
        "length": 6
      },
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "SI": [
    [
      {
        "propertyType": "ZIP",
        "length": 4
      },
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ],
  "SK": [
    [
      {
        "propertyType": "ZIP",
        "length": 5
      },
      {
        "propertyType": "LOCALITY"
      }
    ],
    [
      {
        "propertyType": "COUNTRY"
      }
    ]
  ]
}
